import {Injectable, OnDestroy} from '@angular/core'
import { Router } from '@angular/router'
import {BehaviorSubject, Observable, of, Subject} from 'rxjs'
import {map, takeUntil} from "rxjs/operators";
import {VssUiConfig} from '../../vss-ui.model';

@Injectable({
  providedIn: 'root'
})
export class PermissionService implements OnDestroy{
  private _destroy$: Subject<void> = new Subject<void>()
  roleAdmin = 'ROLE_ADMIN'
  userRules$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([])
  menuObs = new BehaviorSubject<any[]>([])

  constructor(
    private _router: Router,
    private _vssConfig: VssUiConfig,
  ) {
    // Set api getRules
    this.roleAdmin = _vssConfig.roleAdmin
  }

  get userRules() {
    return this.userRules$.value
  }

  ngOnDestroy() {
    this._destroy$.next()
    this._destroy$.complete()
    this._destroy$.unsubscribe()
  }

  __checkPassAllRule(rules: string[]) {
    return !rules.length || this.userRules.includes(this.roleAdmin)
    // return !rules.length
  }

  canActiveRule(rules: string[]): Observable<boolean> {
    return this.userRules$.pipe(
      takeUntil(this._destroy$),
      map(res => {
        return this.__checkPassAllRule(rules) || !!rules.find(r => res.includes(r))
      })
    )
  }

  canActiveRuleBool(rules: string[]): boolean {
    if (this.__checkPassAllRule(rules)) {
      return true
    }
    const existRoles = rules.find(r => this.userRules.includes(r))
    return !!existRoles
  }

  setRuleUser(rules: string[]) {
    this.userRules$.next(rules)
    // this.store.dispatch(ReplaceUserRules({payload: {rules}}))
  }

  getMenu(): Observable<any> {
    return this.menuObs.asObservable();
  }

  setMenu(data: any) {
    this.menuObs.next(data)
  }

}
